import { Pipe, PipeTransform } from '@angular/core';

import { PhxTranslatePipe } from '../../translation/phx-translation.pipe';

type PhxUnitType =
  | 'fuel'
  | 'fuelEfficiency'
  | 'fuelEfficiency-km/l'
  | 'speed'
  | 'acceleration'
  | 'length'
  | 'weight'
  | 'temperature'
  | 'distanceSqM'
  | 'distanceSqKm'
  | 'pressure'
  | 'weightTonne'
  | 'distance';

@Pipe({ name: 'phxMetricUnits' })
export class PhxMetricUnitsPipe implements PipeTransform {
  constructor(private _phxTranslate: PhxTranslatePipe) {}

  /**
   * This function returns metric or imperial unit based upon the type of quantity.
   *
   * @param {boolean} isMetricUnits Flag to decide between metric or imperial units
   * @param {PhxUnitType} type The type of quantity for which the units exist; e.g. length, speed, or weight
   * @param {any} [quantity] If the quantity is null or undefined, return undefined; to prevent displaying units alone
   * @returns {string} Metric or imperial units
   */
  public transform(isMetricUnits: boolean, type: PhxUnitType, quantity?: any): string {
    if (arguments.length > 2 && (quantity == null || quantity === '')) return undefined;

    switch (type) {
      case 'fuel':
        return isMetricUnits ? this._phxTranslate.transform('l') : this._phxTranslate.transform('gal');
      case 'fuelEfficiency':
        return isMetricUnits ? this._phxTranslate.transform('L/100KM') : this._phxTranslate.transform('MPG');
      case 'fuelEfficiency-km/l':
        return isMetricUnits ? this._phxTranslate.transform('KM/L') : this._phxTranslate.transform('MPG');
      case 'speed':
        return isMetricUnits ? this._phxTranslate.transform('kph') : this._phxTranslate.transform('mph');
      case 'acceleration':
        return isMetricUnits ? this._phxTranslate.transform('kph/s') : this._phxTranslate.transform('mph/s');
      case 'length':
        return isMetricUnits ? this._phxTranslate.transform('m') : this._phxTranslate.transform('ft');
      case 'weight':
        return isMetricUnits ? this._phxTranslate.transform('kg') : this._phxTranslate.transform('lbs');
      case 'temperature':
        return isMetricUnits ? this._phxTranslate.transform('°C') : this._phxTranslate.transform('°F');
      case 'distanceSqM':
        return isMetricUnits ? this._phxTranslate.transform('square meters') : this._phxTranslate.transform('square feet');
      case 'distanceSqKm':
        return isMetricUnits ? this._phxTranslate.transform('square kilometers') : this._phxTranslate.transform('square miles');
      case 'pressure':
        return isMetricUnits ? this._phxTranslate.transform('kPa') : this._phxTranslate.transform('psi');
      case 'weightTonne':
        return isMetricUnits ? this._phxTranslate.transform('tonne') : this._phxTranslate.transform('ton');
      case 'distance':
        return isMetricUnits ? this._phxTranslate.transform('km') : this._phxTranslate.transform('mi');
      default:
        throw new Error(`Unknown unit type: ${type}`);
    }
  }
}
